
import Vue, { PropType } from 'vue'
import { Sensor } from '@/models'

import SensorListHeader from './SensorListHeader.vue'
import SensorListItem from './SensorListItem.vue'

export default Vue.extend({
  name: 'SensorList',

  props: {
    sensors: Array as PropType<Array<Sensor>>,
  },

  components: {
    SensorListHeader,
    SensorListItem
  },
})
